import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../../../configs/colors';

export const FilterSection = styled(Box)({
  marginBottom: '24px',
});

export const FilterSectionTitle = styled(Box)({
  fontWeight: 700,
  fontSize: '0.72rem',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  color: COLORS.DarkGray,
  marginBottom: '10px',
});

export const FilterOptionsGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))',
  gap: '8px',
});

interface FilterOptionProps {
  active?: boolean;
}

export const FilterOption = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})<FilterOptionProps>(({ active }) => ({
  padding: '10px 12px',
  borderRadius: '10px',
  border: active ? 'none' : '1.5px solid rgba(0, 0, 0, 0.1)',
  background: active
    ? `linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%)`
    : COLORS.BackgroundGrey,
  color: active ? COLORS.White : COLORS.DarkGray,
  fontWeight: 600,
  fontSize: '0.8rem',
  cursor: 'pointer',
  transition: 'all 0.2s',
  textAlign: 'center',
  fontFamily: 'inherit',
  boxShadow: active ? '0 4px 12px rgba(23, 104, 120, 0.25)' : 'none',
  '&:active': {
    transform: 'scale(0.97)',
  },
  '&:focus-visible': {
    outline: `2px solid ${COLORS.NavyBlue}`,
    outlineOffset: '2px',
  },
}));

export const ApplyButton = styled('button')({
  width: '100%',
  background: `linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%)`,
  color: COLORS.White,
  border: 'none',
  padding: '14px',
  borderRadius: '12px',
  fontWeight: 700,
  fontSize: '0.9rem',
  cursor: 'pointer',
  boxShadow: '0 4px 12px rgba(23, 104, 120, 0.3)',
  fontFamily: 'inherit',
  transition: 'all 0.2s',
  '&:active': {
    transform: 'scale(0.98)',
  },
});
